import create from 'zustand'
import api from '../utils/api'
import useToastContext from '../hooks/useToastContext'

const url = '/constructions'

const initialState = {
  constructions: [],
  isLoading: false,
  error: null,
  count: 0,
  constructionById: null,
  errorItems: [],
  countCreated: 0,
}
const useConstructionStore = create((set) => ({
  ...initialState,

  cleanStoreErrors: () => {
    set({
      errorItems: [],
      countCreated: 0,
    })
  },
  fetchConstructions: async (params) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.get(url, { params, includeToken: true })
      const data = await response.data
      set({ constructions: data.data, count: data.count, isLoading: false })
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  fetchConstructionById: async (id, params) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.get(`${url}/${id}/`, {
        params,
        includeToken: true,
      })
      const data = await response.data
      set({ constructionById: data?.construction, isLoading: false })
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  createConstructionItem: async (item, callback) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.post(url, { ...item })

      set((state) => ({
        isLoading: false,
      }))
      callback && callback()

    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  updateConstructionItem: async (item, callback) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.put(`${url}/${item.id}`, { ...item })

      set((state) => ({
        isLoading: false,
      }))
      callback && callback()
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  createConstructionItems: async (id, data) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.post(`${url}/${id}/constructionMembers`, data)

      set((state) => ({
        errorItems: response?.data?.errors || [],
        countCreated: response?.data?.countCreated || 0,
        isLoading: false,
      }))
      useConstructionStore.getState().fetchConstructionById(id)
    } catch (error) {
      console.log('error', error)
      set({ error: error.message, isLoading: false })
    }
  },

  createConstructionMember: async (id, item) => {
    set({ isLoading: true, error: null })
    try {
      await api.post(`${url}/${id}/constructionMember`, { ...item })
      set((state) => ({
        isLoading: false,
        error: null,
      }))
      useConstructionStore.getState().fetchConstructionById(id)
    } catch (error) {
      set({ error: error?.response?.data?.message, isLoading: false })
    }
  },

  deleteConstruction: async (id) => {
    set({ isLoading: true, error: null })
    try {
      await api.remove(`${url}/${id}`)
      set((state) => ({
        constructions: state.constructions.filter((item) => item.id !== id),
        isLoading: false,
      }))
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  deleteConstructionMember: async (id, memberId) => {
    set({ isLoading: true, error: null })
    try {
      await api.remove(`${url}/${id}/constructionMembers/${memberId}`)
      set((state) => ({
        isLoading: false,
      }))
      useConstructionStore.getState().fetchConstructionById(id)
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  cleanState: () => {
    set((state) => ({
      isLoading: false,
      error: null,
    }))
  },
}))

export default useConstructionStore
